<div class="route-container">
	<router-outlet #ro1="outlet"> </router-outlet>
</div>
<div
	class="backdrop"
	*ngIf="this.globalService.stateStore.backdrop | async"
	[@fadeInOnEnter]
	[@fadeOutOnLeave]
></div>
